import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import NumericInput from 'react-numeric-input';

import DynamicDataGrid from '../common/DynamicDataGrid/DynamicDataGrid';
import { numberWithCommas } from '../../util/CommonUtils';
import FunctionBoxButtonGroupV2 from './FunctionBoxButtonGroupV2';

const commaFormatter = ({ value }) => <div>{numberWithCommas(value)}</div>;

commaFormatter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

class FunctionBoxNTitleV2 extends Component {
  static getColumns() {
    return [
      { key: 'description', name: 'Description', sortable: true, width: 150 },
      { key: 'keyword', name: 'Keyword', sortable: true, width: 150 },
      {
        key: 'midpoint',
        name: 'Midpoint',
        sortable: true,
        editable: true,
        width: 150,
      },
      {
        key: 'weight',
        name: 'Weight',
        sortable: true,
        width: 150,
        formatter: commaFormatter,
      },
      {
        key: 'total',
        name: 'Total',
        sortable: true,
        width: 100,
        formatter: commaFormatter,
      },
    ];
  }

  constructor(props) {
    super(props);
    this.state = {
      isWeighted: false,
      lowerBound: 4,
      upperBound: 1,
      rowsData: this.props.sampleWeightedValues
        ? this.getRowsData(this.props.sampleWeightedValues)
        : [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.sampleWeightedValues &&
      this.props.sampleWeightedValues !== nextProps.sampleWeightedValues
    ) {
      this.setState({
        rowsData: this.getRowsData(nextProps.sampleWeightedValues),
      });
    }
  }

  getRowsData = sampleWeightedValues => {
    if (sampleWeightedValues.length > 0) {
      return this.props.selectedTargets.map((item, index) => ({
        description: item.shortText,
        keyword: item.keyword,
        midpoint: item.midpoint ? item.midpoint : 0,
        weight: sampleWeightedValues[index].weighted,
        total: item.midpoint
          ? item.midpoint * sampleWeightedValues[index].weighted
          : 0,
      }));
    }

    return [];
  };

  handleSampleWeighted = isWeighted => this.setState({ isWeighted });

  createExpression = () => {
    let expressionKeyword = !this.state.isWeighted
      ? 'NTILE ( VOLUME ( '
      : 'NTILEWT ( VOLUME ( ';

    expressionKeyword = this.state.rowsData.reduce(
      (acc, item) => `${acc} ${item.keyword} , ${item.midpoint} , `,
      expressionKeyword,
    );

    expressionKeyword = expressionKeyword.slice(0, -2);

    expressionKeyword = `${expressionKeyword} ) , ${this.state.lowerBound} , ${
      this.state.upperBound
      } )`;

    return expressionKeyword;
  };


  createSmartSearchArray = () => {
    const selectedTargets = _.cloneDeep(this.props.selectedTargets);
    const objSmartSearchArray = {};
    const objectsAdded = [];
    const expressionFormed = [];
    const tags = [];

    selectedTargets.forEach(target => {
      const breadcrumbList = JSON.parse(window.localStorage.getItem('breadCrumb'));
      const breadCrumbValue = breadcrumbList ? breadcrumbList.reverse().join(' > ') : undefined;

      target.breadcrumbs = breadCrumbValue;
      objectsAdded.push(target);
      expressionFormed.push(target.keyword);
      tags.push(target.shortText);
    });
    objSmartSearchArray.objectsAdded = objectsAdded;
    objSmartSearchArray.expressionFormed = expressionFormed;
    objSmartSearchArray.tags = tags;
    return objSmartSearchArray;
  }


  moveAppendToCodingBox = isMove =>
    this.props.moveAppendToCodingBox(isMove, this.createExpression(), this.createSmartSearchArray());

  moveToColumns = () => {
    if (this.props.functionTitle) {
      this.props.moveToColumns(this.createExpression(), this.createSmartSearchArray());
    } else {
      this.props.moveToColumns();
    }
  };

  moveToRows = () => {
    if (this.props.functionTitle) {
      this.props.moveToRows(this.createExpression(), this.createSmartSearchArray());
    } else {
      this.props.moveToRows();
    }
  };

  addToDefinitionModal = () => {
    if (this.props.functionTitle) {
      this.props.addToDefinition(this.createExpression());
    } else {
      this.props.addToDefinition();
    }
  };

  handleDataUpdate = (gridRows, rowNumber, { midpoint }) => {
    const formattedMidPoint = midpoint !== '' ? midpoint : 0;
    const rowsData = gridRows;
    const updatedRow = {
      ...gridRows[rowNumber],
      total: (midpoint * gridRows[rowNumber].weight).toFixed(),
      midpoint: formattedMidPoint,
    };
    Object.assign(rowsData[rowNumber], updatedRow);
    this.setState({ rowsData });
  };

  render() {
    return (
      <div>
        <div className="row expanded">
          <div className="small-12 medium-8 large-9 columns padding-left-0">
            <DynamicDataGrid
              gridCategory="FunctionBoxGrid"
              className="saved-crosstab-grid"
              gridHeight={320}
              gridWidth={700}
              rows={this.state.rowsData}
              columns={this.constructor.getColumns()}
              rowSelectionType="Single"
              isCellSelectable
              minimunRows={8}
              onDataUpdate={this.handleDataUpdate}
            />
          </div>
          <div className="small-12 medium-3 large-3 columns function-position">
            <div className="row">
              <div className="numeric-input-text">
                <label htmlFor="lower-bound" className="float-right">
                  Number of Groups
                </label>
              </div>
              <div className="numeric-input-control">
                <NumericInput
                  min={1}
                  max={10}
                  value={this.state.lowerBound}
                  className="form-control"
                  onChange={value => this.setState({ lowerBound: value })}
                />
              </div>
            </div>
            <div className="row clearfix">
              <div className="numeric-input-text">
                <label htmlFor="upper-bound" className="float-right" />
              </div>
              <div className="numeric-input-control">
                <NumericInput
                  min={1}
                  max={10}
                  value={this.state.upperBound}
                  className="form-control"
                  onChange={value => this.setState({ upperBound: value })}
                />
              </div>
            </div>
            <div className="row">
              <div className="small-6 columns">
                <input
                  type="radio"
                  name="Sample"
                  id="Sample"
                  onChange={() => this.handleSampleWeighted(false)}
                  checked={!this.state.isWeighted}
                />
                <label htmlFor="Sample">Sample</label>
              </div>
              <div className="small-6 columns">
                <input
                  type="radio"
                  name="Weighted"
                  id="Weighted"
                  onChange={() => this.handleSampleWeighted(true)}
                  checked={this.state.isWeighted}
                />
                <label htmlFor="Weighted">Weighted</label>
              </div>
            </div>
            <div className="clearfix">
              <FunctionBoxButtonGroupV2
                moveAppendToCodingBox={this.moveAppendToCodingBox}
                moveToColumns={this.moveToColumns}
                moveToRows={this.moveToRows}
                addToDefinitionModal={this.addToDefinitionModal}
                noExpressionBox={this.props.noExpressionBox}
                noCRB={this.props.noCRB}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
FunctionBoxNTitleV2.propTypes = {
  functionTitle: PropTypes.string,
  moveAppendToCodingBox: PropTypes.func,
  moveToRows: PropTypes.func,
  moveToColumns: PropTypes.func,
  addToDefinition: PropTypes.func,
  sampleWeightedValues: PropTypes.arrayOf(PropTypes.object),
  selectedTargets: PropTypes.arrayOf(PropTypes.object),
  noExpressionBox: PropTypes.bool,
  noCRB: PropTypes.bool,
};


export default FunctionBoxNTitleV2;
